// apps/client/src/components/errors/Error403.tsx
import React from 'react';
import ErrorTemplate, { ErrorButtons } from './ErrorTemplate';
import EmojiFoodBeverageIcon from '@mui/icons-material/EmojiFoodBeverage';

export const Error403: React.FC = () => {
  return (
    <ErrorTemplate
      title="418"
      heading="I'm a teapot"
      message="The server refuses the attempt to brew coffee with a teapot."
      buttons={[ErrorButtons.HOME, ErrorButtons.BACK]}
      icon={<EmojiFoodBeverageIcon sx={{ fontSize: '6rem', mb: 2, color: 'text.secondary' }} />}
    />
  );
};

export default Error403;
